enum Direction {
  RTL = "rtl",
  LTR = "ltr"
}

export default Direction;
